import {
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import InfoIcon from "@material-ui/icons/Info";
import * as React from "react";
import {
  AutocompleteInput,
  Button,
  CheckboxGroupInput,
  Create,
  FileField,
  FileInput,
  NumberInput,
  RadioButtonGroupInput,
  SelectInput,
  TextInput,
  Toolbar,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { useAppDataProvider } from "../../../../dataprovider";
import LocalRepairStatusChip from "../LocalRepairStatusChip";
import { OffWingChoices, PnSelectionChoices, ReleaseTypeChoices, RequestTypeChoices } from "../../Constant/Source";
import { PbhRequestOrderModel } from "../../Models/PbhRequestOrderModel";
import { PbhRequestRemark } from "../../Models/PbhRequestRemarkModel";
import {
  HomeBaseCategories,
  HomeBaseReplenishmentArray,
  HomeBaseReplenishmentArrayForQty,
  IncludeHomeBaseReplenishmentArray,
  MelCategoryRequiredArray,
  RequirementCategory,
} from "../../../../Enums/RequirementCategory";
import { FileAcceptWhiteList, PbhUnserviceableReplenishmentType } from "../../../../../src/Constants/Constant";
import moment from "moment";
import { DownloadButton, useAuth } from "@airborne/react-admin";
import { OwnerType, OwnerTypeDesc } from "../../../../../src/Enums/OwnerTypes";
import { ComponentTypesChoices } from "../../../../../src/Enums/ComponentTypes";
import { SSMTypeChoices } from "../../../../../src/Enums/SsmTypes";
import { PbhRequestOrderFileRelationModel } from "../../Models/PbhRequestOrderFileRelationModel";
import { PbhRequestFileType } from "../../../../../src/Enums/PbhRequestFileType";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const PostCreate = props => {
  const [file, setFile] = React.useState<PbhRequestOrderFileRelationModel>(new PbhRequestOrderFileRelationModel());
  const [homeBaseRemarkVisible, setHomeBaseRemarkVisible] = React.useState(false);
  const [homeBaseRemarkVisibleForQty, setHomeBaseRemarkVisibleForQty] = React.useState(false);
  const [isHomebaseQtyWarning, setIsHomebaseQtyWarning] = React.useState(false);
  const [isExistPngFromCdm, setIsExistPngFromCdm] = React.useState(false);
  const [cdmPnAndPng, setCdmPnAndPng] = React.useState<any>({});
  const [loading, setLoading] = React.useState(false);
  const [createLoading, setCreateLoading] = React.useState(false);
  const [pnSelectionType, setPnSelectionType] = React.useState(true);
  const [selectedData, setSelectedData] = React.useState(null as any);
  const [selectedPn, setSelectedPn] = React.useState(null as any);
  const [selectedRequirementCategory, setSelectedRequirementCategory] = React.useState(null as any);
  const [selectedAirportCode, setSelectedAirportCode] = React.useState(null as any);
  const [selectedPnText, setSelectedPnText] = React.useState(null as any);
  const [formDisabled, setFormDisabled] = React.useState(false as boolean);
  const [unsvcPnText, setUnsvcPnText] = React.useState("" as string);
  const [pnDifferenceRemarkVisible, setPnDifferenceRemarkVisible] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [isHardTime, setIsHardTime] = React.useState<boolean>(false);
  const isHardTimeRef = React.useRef<boolean>(false);
  const [remarkRequired, setRemarkRequired] = React.useState(false);
  const [rejectRemarkRequired, setRejectRemarkRequired] = React.useState(false);
  const [unsvcPnSnRequired, setUnsvcPnSnRequired] = React.useState(false);
  const [isConsignment, setIsConsignment] = React.useState(false);
  const [isRejectionOrder, setIsRejectionOrder] = React.useState(false);
  const [warningDialogMessage, setWarningDialogMessage] = React.useState("");
  const [isUsedSnRequired, setIsUsedSnRequired] = React.useState(false);
  const [isMelCategoryRequired, setIsMelCategoryRequired] = React.useState(false);
  const [defectReasonRequired, setDefectReasonRequired] = React.useState(false as boolean);
  const [isLocalRepair, setIsLocalRepair] = React.useState(false);
  const [localRepairPn, setLocalRepairPn] = React.useState<string | undefined>(undefined);
  const history = useHistory();
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();

  const classes = useStyles();

  React.useEffect(() => {
    setSelectedData(props.selectedData);
    setFormDisabled(props.selectedData.contractIsValid === false);
    if (props.selectedData.contractIsValid === false) {
      setWarningDialogMessage("This request cannot be registered because the contract has expired or is inactive.");
    }
  }, [props]);
  React.useEffect(() => {
    GetPnMaster();
  }, [selectedPnText]);
  React.useEffect(() => {
    setOpen(formDisabled);
  }, [formDisabled]);
  React.useEffect(() => {
    CheckPnAndRequirementCategory();
  }, [selectedRequirementCategory, isHardTime]);
  React.useEffect(() => {
    if (selectedPn?.pn) {
      HardTimeControl();
    }
  }, [selectedPn]);

  const CreateOrderButtonClick = async e => {
    CreateOrder(e);
    setCreateLoading(true);
  };

  const CreateOrder = async e => {
    let pbhRequestOrderModel: PbhRequestOrderModel = new PbhRequestOrderModel();
    pbhRequestOrderModel.AircraftId = selectedData?.acMaster?.id;
    pbhRequestOrderModel.AirportCode = e?.airportCode;
    pbhRequestOrderModel.AtaChapter = e?.ataChapter;
    pbhRequestOrderModel.ComponentType = e?.componentType;
    pbhRequestOrderModel.SsmType = e?.ssmType;
    pbhRequestOrderModel.Quantity = e?.quantity;
    pbhRequestOrderModel.AttentionName = e?.attentionName;
    pbhRequestOrderModel.AttentionPhone = e?.attentionPhone;
    pbhRequestOrderModel.ConsigneeAddress = e?.consigneeAddress;
    pbhRequestOrderModel.ConsigneeName = e?.consigneeName;
    pbhRequestOrderModel.ContractId = selectedData.contract.id;
    pbhRequestOrderModel.CustomerPo = e?.customerPo;
    pbhRequestOrderModel.CustomerPoLine = e?.customerPoLine;
    pbhRequestOrderModel.DefectReason = e?.defectReason;
    pbhRequestOrderModel.Email = e?.email;
    pbhRequestOrderModel.MelCategory = e?.melCategory;
    pbhRequestOrderModel.MelDueDate = e?.melDueDate;
    pbhRequestOrderModel.OffWing = e?.offWing;
    pbhRequestOrderModel.Pn = pnSelectionType === false ? e?.pnText : selectedPn.pn;
    pbhRequestOrderModel.PreDefinedComponentId = pnSelectionType === false ? 0 : e?.pn;
    pbhRequestOrderModel.PnDescription = e?.pnDescription;
    pbhRequestOrderModel.ReleaseType = e?.releaseType.toString();
    pbhRequestOrderModel.ShippingAddress = e?.shippingAddress;
    pbhRequestOrderModel.RequirementCategory = e?.requirementCategory;
    pbhRequestOrderModel.RequirementCategoryText = selectedRequirementCategory?.category;
    pbhRequestOrderModel.CustomerCode = selectedData?.contract?.customer;
    pbhRequestOrderModel.AcRegistration = selectedData?.acMaster?.acReg;
    pbhRequestOrderModel.RequestRemark = new PbhRequestRemark();
    pbhRequestOrderModel.RequestRemark.Remark = e?.customerRemark;
    pbhRequestOrderModel.PnDifferenceRemark = e?.pnDifferenceRemark ?? "";
    pbhRequestOrderModel.HomeBaseRemark = e?.homeBaseRemark ?? "";
    pbhRequestOrderModel.UsedSn = e?.usedSn ?? "";
    pbhRequestOrderModel.UnserviceablePn = e?.unserviceablePN ?? "";
    pbhRequestOrderModel.UnserviceableSn = e?.unserviceableSN ?? "";
    pbhRequestOrderModel.RequestedDeliveryDate = e?.requestedDeliveryDate;
    pbhRequestOrderModel.File = file;
    pbhRequestOrderModel.IsLocalRepair = e?.isLocalRepair ?? false;

    dataProvider
      .createPbhRequestOrder(pbhRequestOrderModel)
      .then(response => {
        let requestOrder = response.data;
        notify(`Record created`, "success", false, true);
        history.push("/pbhrequestorders/" + requestOrder.id);
      })
      .catch(response => {
        notify(`${response}`, "error", false, true);
      })
      .finally(() => {
        setCreateLoading(false);
      });
  };

  const WarningDialog = () => {
    const handleClose = () => setOpen(false);

    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{"Information"}</DialogTitle>
        <Divider />
        <DialogContent>
          <div>{warningDialogMessage}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} label="Close" />
        </DialogActions>
      </Dialog>
    );
  };

  const checkLocalRepair = (_ownerCode: string | undefined, pn: string | undefined) => {
    setLocalRepairPn(pn || undefined);
  };

  const pnChangeEvent = form => async e => {
    let selectedPnId = e;
    let selectedPn = selectedData?.pnList.filter(pn => pn.id === selectedPnId)[0];
    setSelectedPn(selectedPn);
    validationToPn(selectedPn);
    setUnsvcPnText(selectedPn?.pn);
    // Clear unserviceable fields when requested PN changes
    form.change("unserviceablePN", "");
    form.change("unserviceableSN", "");
    // Await HardTimeControl BEFORE GetConsignments to prevent race condition:
    // GetConsignments can auto-set requirementCategory which triggers CheckPnAndRequirementCategory
    // before the HardTime API response arrives, causing isHardTime to be read as false
    if (selectedPn?.pn) {
      await HardTimeControl(selectedPn.pn);
    }
    GetConsignments(selectedPn, form);
    checkLocalRepair(user?.ownerCode, selectedPn?.pn);
  };

  const validationToPn = selectedPn => {
    setFormDisabled(selectedPn.pnIsValid === false);
    if (selectedPn.pnIsValid === false)
      setWarningDialogMessage("Request cannot be processed due to component has no service agreement.");
  };

  const pnTextBlurEvent = form => async e => {
    let textValue = e?.target?.value;
    setSelectedPnText(textValue);

    // Clear unserviceable fields when requested PN changes
    form.change("unserviceablePN", "");
    form.change("unserviceableSN", "");

    // Same race condition fix as pnChangeEvent: await HardTime before GetConsignments
    if (textValue) {
      await HardTimeControl(textValue);
    }
    GetConsignments({ pn: textValue, contractNumber: selectedData?.id }, form);
    checkLocalRepair(user?.ownerCode, textValue);
  };

  const unserviceableSnBlurEvent = form => e => {
    if (e?.target?.value !== null && e?.target?.value !== undefined) {
      if (e?.target?.value !== "") {
        dataProvider.getPbhRejectionOrder(unsvcPnText, e?.target?.value).then(response => {
          if (response.data === true) {
            setIsRejectionOrder(true);
          } else {
            setIsRejectionOrder(false);
          }
        });
      } else {
        setIsRejectionOrder(false);
      }
    }
  };

  const airportCodeChangeEvent = e => {
    let airportCode = e;
    let selectedAirportCode = selectedData?.addressList.filter(pn => pn.airportCode === airportCode)[0];
    setSelectedAirportCode(selectedAirportCode);
  };

  const pnSelectionTypeChangeEvent = form => value => {
    setSelectedPn(null);
    isHardTimeRef.current = false;
    setIsHardTime(false);
    setUnsvcPnText("");
    form.change("pn", "");
    form.change("pnText", "");
    form.change("unserviceablePN", "");
    form.change("unserviceableSN", "");
    setPnDifferenceRemarkVisible(false);
    setPnSelectionType(value);
    setLocalRepairPn(undefined);
  };

  const requirementCategoryChangeEvent = form => e => {
    let requirementCategoryId = e.target.value;
    let selectedRequirementCategory = selectedData?.requirementCategoryList.filter(
      rq => rq.id === requirementCategoryId
    )[0];
    setSelectedRequirementCategory(selectedRequirementCategory);

    var isHomeBaseReplenishmentReqCat = selectedData?.requirementCategoryList?.find(
      x => HomeBaseReplenishmentArray.includes(x.category) && x.id === selectedRequirementCategory?.id
    );
    if (isHomeBaseReplenishmentReqCat) {
      setIsUsedSnRequired(true);
    } else {
      setIsUsedSnRequired(false);
    }

    var isMelCategoryRequired = selectedData?.requirementCategoryList?.find(
      x => MelCategoryRequiredArray.includes(x.category) && x.id === selectedRequirementCategory?.id
    );

    isMelCategoryRequired ? setIsMelCategoryRequired(true) : setIsMelCategoryRequired(false);

    // var homebaseCategory = selectedData?.requirementCategoryList?.find(
    //   x => HomeBaseCategories.includes(x.category) && x.id === selectedRequirementCategory?.id
    // );
    if (isConsignment) {
      notify(`This is HBK part. Are you sure that you’ll chose another category?`);
    }
    if (isConsignment && !isHomeBaseReplenishmentReqCat) {
      setHomeBaseRemarkVisible(true);
    } else {
      setHomeBaseRemarkVisible(false);
    }

    var isHomeBaseReplenishmentReqCatForQty = selectedData?.requirementCategoryList?.find(
      x => HomeBaseReplenishmentArrayForQty.includes(x.category) && x.id === selectedRequirementCategory?.id
    );

    if (isHomebaseQtyWarning) {
      if (isHomeBaseReplenishmentReqCatForQty) {
        setWarningDialogMessage(
          `Quantity of open homebase replenishment requests can not greater than quantity specified in the agreement. Please select another requirement category.`
        );
        setOpen(true);
      } else {
        setHomeBaseRemarkVisibleForQty(true);
      }
    }
    if (isExistPngFromCdm && isHomeBaseReplenishmentReqCat) {
      notify(
        `Requested PN: ${cdmPnAndPng?.pn} is alternative to HBK PN: ${cdmPnAndPng?.png}. If you need the part for HBK replenishment, please select HBK replenishment category.`
      );
    }
    form.change("isLocalRepair", isLocalRepair);
  };

  function handlePnTextChange(e) {
    let newValue = e.target.value;
    setUnsvcPnText(newValue);
  }

  function handleUnserviceablePnTextChange(e) {
    if (e?.target?.value !== null && e?.target?.value !== undefined) {
      let newValue = e.target.value;
      if (newValue === unsvcPnText) {
        setPnDifferenceRemarkVisible(false);
      } else {
        setPnDifferenceRemarkVisible(true);
      }
    }
  }

  const isSubmitButtonDisabled = (): boolean => {
    var isHomeBaseReplenishmentReqCat = selectedData?.requirementCategoryList?.find(
      x => HomeBaseReplenishmentArrayForQty.includes(x.category) && x.id === selectedRequirementCategory?.id
    );
    if ((isHomebaseQtyWarning && isHomeBaseReplenishmentReqCat) || createLoading || formDisabled) {
      return true;
    }
    return false;
  };

  const CheckPnAndRequirementCategory = () => {
    const hardTime = isHardTimeRef.current;
    setRemarkRequired(false);

    if (!selectedRequirementCategory?.category) {
      setDefectReasonRequired(false);
      setUnsvcPnSnRequired(false);
      return;
    }

    if (
      [
        RequirementCategory.ReplenishmentHomebase,
        RequirementCategory.ReplenishmentHomebaseAog,
        RequirementCategory.ReplenishmentCustomerAsset,
        RequirementCategory.ReplenishmentCustomerAssetAog,
      ].includes(selectedRequirementCategory?.category)
    ) {
      var isDefectReasonRequired =
        hardTime || selectedRequirementCategory?.category === RequirementCategory.ReplenishmentCustomerAsset;
      setDefectReasonRequired(isDefectReasonRequired);
      setUnsvcPnSnRequired(true);
    } else {
      if (hardTime) {
        if (selectedRequirementCategory?.category) {
          if (
            !(
              selectedRequirementCategory?.category === RequirementCategory.ScheduledLeaseReturnMaintenance ||
              selectedRequirementCategory?.category === RequirementCategory.ScheduledBaseMaintenance
            )
          ) {
            setWarningDialogMessage(
              "This component has hard time. You should select scheduled as requirement category. Do you want to continue?"
            );
            setDefectReasonRequired(true);
            setOpen(true);
          } else {
            setDefectReasonRequired(false);
          }
          if (selectedRequirementCategory?.category === RequirementCategory.Scheduled) {
            setRemarkRequired(true);
          }
        }
      } else {
        setDefectReasonRequired(true);
      }
      setUnsvcPnSnRequired(false);
    }
  };

  const GetPnMaster = async () => {
    setLoading(true);
    if (selectedPnText !== null && selectedPnText !== undefined) {
      dataProvider
        .getPnMasterByPn(selectedPnText)
        .then((response: any) => {
          if (response?.data?.id === null) {
            clear();
            return;
          }
          let selectedPn = { ataChapter: response.data.chapter, description: response.data.pnDescription };
          setSelectedPn(selectedPn);
          setLoading(false);
        })
        .catch(error => {
          console.log(error);
          setSelectedPn(null);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    const clear = () => {
      setSelectedPn(null);
      setLoading(false);
    };
  };

  const GetInvPngList = (pn, contractId) => {
    setIsExistPngFromCdm(false);
    setCdmPnAndPng({});
    dataProvider
      .getList("invpngs/getcustomlist", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "ASC" },
        filter: { pn__eq: pn },
      })
      .then(response => {
        var pngList = response?.data?.filter?.(x => x.id != pn)?.map?.(x => x.id);
        if (pngList?.length > 0) {
          dataProvider.getListConsignments(null, contractId).then(response => {
            if (response?.data?.length > 0) {
              var cmdPnList = response?.data;
              var isExistPng = cmdPnList.find((x: any) => pngList.includes(x.mpn));
              if (isExistPng) {
                setIsExistPngFromCdm(true);
                setCdmPnAndPng({ pn: pn, png: isExistPng.mpn });
                var isHomeBaseReplenishmentReqCat = selectedData?.requirementCategoryList?.find(
                  x => x.id === selectedRequirementCategory?.id && HomeBaseReplenishmentArray.includes(x.category)
                );
                if (isHomeBaseReplenishmentReqCat) {
                  notify(
                    `Requested PN: ${pn} is alternative to HBK PN: ${isExistPng.mpn}. If you need the part for HBK replenishment, please select HBK replenishment category.`
                  );
                }
              }
            }
          });
        }
      });
  };

  const GetConsignments = async (selectedPn, form) => {
    await dataProvider
      .getListConsignments(selectedPn?.pn, selectedPn?.contractNumber)
      .then((response: any) => {
        if (response?.data?.length > 0) {
          setIsConsignment(true);
          var requirementCategory = selectedData?.requirementCategoryList?.find(x =>
            HomeBaseReplenishmentArray.includes(x.category)
          );
          if (requirementCategory?.id > 0) {
            GetPnQtyInfo(selectedPn?.pn, selectedData?.id, selectedData?.contract?.customer, requirementCategory.id);
            form.change("requirementCategory", requirementCategory?.id);
            requirementCategoryChangeEvent(form)({ target: { value: requirementCategory?.id } });
            setHomeBaseRemarkVisible(false);
          } else {
            setHomeBaseRemarkVisible(true);
          }
        } else {
          setHomeBaseRemarkVisible(false);
          setIsConsignment(false);
          GetInvPngList(selectedPn?.pn, selectedPn?.contractNumber);
        }
      })
      .catch(error => {
        setHomeBaseRemarkVisible(false);
        setIsConsignment(false);
      });
  };

  const GetPnQtyInfo = async (pn, contractNumber, customerCode, requirementCategory) => {
    dataProvider
      .getHomeBaseQtyInfo({ contractNumber: contractNumber, customerCode: customerCode, pn: pn })
      .then((response: any) => {
        setHomeBaseRemarkVisibleForQty(false);
        setIsHomebaseQtyWarning(false);
        if (response?.data?.data) {
          var data = response.data.data;
          let homebaseQty = IncludeHomeBaseReplenishmentArray.includes(requirementCategory)
            ? (data?.homebasePnQty ?? 0)
            : 0;
          var isQtyWarning = data?.cdmQty === 0 ? false : homebaseQty + data?.requestQty >= data.cdmQty;
          if (isQtyWarning) {
            setIsHomebaseQtyWarning(true);
            var isHomeBaseReplenishmentReqCat = selectedData?.requirementCategoryList?.find(
              x => x.id === requirementCategory && HomeBaseReplenishmentArrayForQty.includes(x.category)
            );
            if (isHomeBaseReplenishmentReqCat) {
              setWarningDialogMessage(
                `Quantity of open homebase replenishment requests can not greater than quantity specified in the agreement. Please select another requirement category.`
              );
              setOpen(true);
            } else {
              setHomeBaseRemarkVisibleForQty(true);
            }
          }
        }
      })
      .catch(error => {});
  };

  const HardTimeControl = async (pn?: string): Promise<void> => {
    const pnToUse = pn ?? selectedPn?.pn;
    if (!pnToUse) return;
    try {
      const response: any = await dataProvider.getPnHardTimeFromPn(pnToUse);
      const result = response?.data[0] ? true : false;
      isHardTimeRef.current = result;
      setIsHardTime(result);
    } catch {
      isHardTimeRef.current = false;
      setIsHardTime(false);
    }
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };

  const changeReplenishmentReason = form => value => {
    const formValue = form?.getState?.()?.values ?? {};

    formValue.replenishmentReason === 0 ? setRejectRemarkRequired(true) : setRejectRemarkRequired(false);
  };

  const getRddDisabled = (): boolean => {
    if (selectedRequirementCategory?.category === RequirementCategory.ScheduledHardTime) {
      return false;
    }

    return true;
  };
  const handleFileChange = fileObj => {
    let file: File = fileObj[0];
    const formData = new FormData();
    formData.append("file", file);
    dataProvider.post("minio", formData).then(result => {
      var objectKey = result?.data?.objectKey;
      const tempFile = { id: 0, name: file.name, objectKey: objectKey };
      const createFile = new PbhRequestOrderFileRelationModel();
      createFile.PbhRequestFileTypeEnum = PbhRequestFileType.Defect;
      createFile.PbhRequestFileTypeGroupEnum = PbhRequestFileType.Info;
      createFile.File = tempFile;
      setFile(createFile);
      notify(`File uploaded successfully`, "success", false, true);
    });
  };
  const filesVisible = (): boolean => {
    var flyDubai = OwnerTypeDesc.find(x => x.Value == OwnerType.AARFLYDB)?.Description;
    return user?.ownerCode === flyDubai;
  };

  return (
    <Form
      onSubmit={CreateOrderButtonClick}
      render={({ handleSubmit, form, values }) => {
        // Helper variable to check if Requested PN is filled based on selection type
        const isRequestedPnFilled = pnSelectionType
          ? values?.pn !== null && values?.pn !== undefined && values?.pn !== ""
          : values?.pnText !== null &&
            values?.pnText !== undefined &&
            values?.pnText !== "" &&
            values?.pnText?.trim() !== "";

        return (
          <form>
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Create {...props}>
                    <>
                      <Separator />
                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Contract Info" />
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="contractName"
                            initialValue={selectedData?.contract?.contractName}
                            validate={required()}
                            fullWidth
                            variant="outlined"
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                          <RadioButtonGroupInput
                            source="requestType"
                            label="Request Type"
                            fullWidth
                            defaultValue={selectedData?.requestType}
                            choices={RequestTypeChoices}
                            validate={required()}
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                      </Grid>
                      <Separator />

                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Order Info" />
                      </Grid>
                      <Grid {...gridContainerProps} alignItems={"flex-start"}>
                        <Grid item xs={12} sm={5}>
                          <RadioButtonGroupInput
                            source="pnSelection"
                            label="PN Selection"
                            initialValue={true}
                            fullWidth
                            choices={PnSelectionChoices}
                            onChange={pnSelectionTypeChangeEvent(form)}
                            validate={required()}
                            variant="outlined"
                            disabled={formDisabled}
                          />
                          {user?.ownerCode == OwnerTypeDesc.find(x => x.Value == OwnerType.SSM)?.Description && (
                            <>
                              <RadioButtonGroupInput
                                source="componentType"
                                label="Component Type"
                                fullWidth
                                choices={ComponentTypesChoices}
                                variant="outlined"
                                disabled={formDisabled}
                              />
                              <NumberInput
                                source="quantity"
                                label="Quantity"
                                fullWidth
                                variant="outlined"
                                disabled={formDisabled}
                              />
                              <SelectInput
                                source="ssmType"
                                label="Type"
                                optionText="Description"
                                optionValue="Value"
                                fullWidth
                                resettable
                                choices={SSMTypeChoices}
                                variant="outlined"
                                disabled={formDisabled}
                              />
                            </>
                          )}

                          <LocalRepairStatusChip
                            ownerCode={user?.ownerCode}
                            pn={localRepairPn}
                            onResult={result => {
                              setIsLocalRepair(result);
                              form.change("isLocalRepair", result);
                            }}
                          />
                          {pnSelectionType === true ? (
                            <AutocompleteInput
                              source="pn"
                              optionText="pn"
                              optionValue="id"
                              label="Requested PN"
                              choices={selectedData?.pnList}
                              onChange={pnChangeEvent(form)}
                              validate={required()}
                              onBlur={resetValidate(form)}
                              variant="outlined"
                              fullWidth
                              disabled={formDisabled}
                            />
                          ) : (
                            <TextInput
                              source="pnText"
                              label="Requested PN"
                              fullWidth
                              resettable
                              variant="outlined"
                              onBlur={pnTextBlurEvent(form)}
                              validate={required()}
                              disabled={formDisabled}
                              onChange={handlePnTextChange}
                            />
                          )}

                          <TextInput
                            source="pnDescription"
                            label="Component Description"
                            initialValue={selectedPn?.description ?? ""}
                            fullWidth
                            disabled={selectedPn !== null || formDisabled}
                            validate={required()}
                            variant="outlined"
                          />
                          <TextInput
                            source="unserviceablePN"
                            label="Core Unit PN"
                            fullWidth
                            resettable
                            variant="outlined"
                            initialValue={unsvcPnText}
                            validate={unsvcPnSnRequired ? required() : []}
                            onChange={handleUnserviceablePnTextChange}
                            disabled={!isRequestedPnFilled || formDisabled}
                          />
                          <TextInput
                            source="unserviceableSN"
                            label="Core Unit SN"
                            fullWidth
                            resettable
                            variant="outlined"
                            validate={unsvcPnSnRequired ? required() : []}
                            onBlur={unserviceableSnBlurEvent(form)}
                            disabled={!isRequestedPnFilled || formDisabled}
                          />
                          {isUsedSnRequired && (
                            <TextInput
                              source="usedSn"
                              label="Used SN"
                              fullWidth
                              resettable
                              variant="outlined"
                              validate={isUsedSnRequired ? required() : []}
                            />
                          )}

                          {isRejectionOrder && (
                            <SelectInput
                              source="replenishmentReason"
                              label="REPLENISHMENT REASON"
                              optionText="replenishmentTypes"
                              optionValue="value"
                              fullWidth
                              resettable
                              choices={PbhUnserviceableReplenishmentType}
                              onChange={changeReplenishmentReason(form)}
                              validate={isRejectionOrder ? required() : []}
                              variant="outlined"
                            />
                          )}

                          {rejectRemarkRequired && isRejectionOrder && (
                            <TextInput
                              source="rejectionRemark"
                              label="Core Unit Rejection Remark"
                              fullWidth
                              resettable
                              variant="outlined"
                              validate={rejectRemarkRequired ? required() : []}
                            />
                          )}

                          {pnDifferenceRemarkVisible && (
                            <TextInput
                              source="pnDifferenceRemark"
                              label="PN Difference Remark"
                              multiline
                              resettable
                              fullWidth
                              rows={3}
                              variant="outlined"
                              validate={required()}
                            />
                          )}
                          {isMelCategoryRequired && (
                            <SelectInput
                              source="melCategory"
                              label="MEL Category"
                              choices={selectedData?.melCategoryList}
                              optionText="id"
                              optionValue="id"
                              fullWidth
                              variant="outlined"
                              validate={isMelCategoryRequired ? required() : []}
                              disabled={formDisabled}
                            />
                          )}

                          {isMelCategoryRequired && (
                            <CustomDatetime
                              fullWidth
                              source="melDueDate"
                              label="MEL Due Date"
                              inputVariant={"dialog"}
                              variant="outlined"
                              validate={isMelCategoryRequired ? required() : []}
                              disabled={formDisabled}
                              showTime
                            />
                          )}

                          {defectReasonRequired && (
                            <TextInput
                              source="defectReason"
                              label="Defect/Task Details"
                              multiline
                              resettable
                              fullWidth
                              rows={3}
                              variant="outlined"
                              validate={defectReasonRequired ? required() : []}
                              disabled={formDisabled}
                            />
                          )}

                          {(homeBaseRemarkVisible || homeBaseRemarkVisibleForQty) && (
                            <TextInput
                              source="homeBaseRemark"
                              label="Home Base Remark"
                              multiline
                              resettable
                              fullWidth
                              rows={3}
                              variant="outlined"
                              validate={required()}
                            />
                          )}

                          {selectedPn && (
                            <>
                              <Chip
                                key={99999}
                                size="medium"
                                style={{ color: "#767676" }}
                                variant="outlined"
                                label={`Access: ${selectedPn?.isAccess ?? "N/A"}`}
                                icon={<InfoIcon />}
                              />
                              <Chip
                                key={99999}
                                style={{ margin: "14px", color: "#767676" }}
                                size="medium"
                                variant="outlined"
                                label={`Repair: ${selectedPn?.isRepair ?? "N/A"}`}
                                icon={<InfoIcon />}
                              />
                            </>
                          )}
                          <RadioButtonGroupInput
                            source="offWing"
                            label="Off Wing"
                            fullWidth
                            choices={OffWingChoices}
                            variant="outlined"
                            validate={required()}
                            disabled={formDisabled}
                          />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                          <NumberInput
                            source="ataChapter"
                            label="Ata Chapter"
                            initialValue={selectedPn?.ataChapter ?? ""}
                            fullWidth
                            disabled={selectedPn !== null || formDisabled}
                            validate={required()}
                            variant="outlined"
                          />
                          <CheckboxGroupInput
                            source="releaseType"
                            choices={ReleaseTypeChoices()}
                            validate={required()}
                            disabled={formDisabled}
                          />
                          <AutocompleteInput
                            source="airportCode"
                            label="Airport Code"
                            optionText="id"
                            optionValue="id"
                            choices={selectedData?.airportCodeList}
                            onChange={airportCodeChangeEvent}
                            suggestionLimit={10}
                            filterToQuery={searchText => ({ id__contains: searchText })}
                            variant="outlined"
                            fullWidth
                            validate={required()}
                            disabled={formDisabled}
                          />
                          <Grid container spacing={2}>
                            <Grid item xs={8} sm={9}>
                              <TextInput
                                fullWidth
                                source="customerPo"
                                label="Customer PO/RO"
                                variant="outlined"
                                validate={required()}
                                disabled={formDisabled}
                              />
                            </Grid>

                            <Grid item xs={4} sm={3}>
                              <TextInput
                                defaultValue={"1"}
                                fullWidth
                                source="customerPoLine"
                                label="Line"
                                variant="outlined"
                                validate={required()}
                                disabled={formDisabled}
                              />
                            </Grid>
                          </Grid>

                          <CustomDatetime
                            fullWidth
                            disabled={getRddDisabled()}
                            source="requestedDeliveryDate"
                            label="Requested Delivery Date"
                            inputVariant={"dialog"}
                            variant="outlined"
                            validate={[
                              minValue(
                                selectedRequirementCategory?.calculatedRDD,
                                "Should be later than RDD " +
                                  moment(selectedRequirementCategory?.calculatedRDD).format("DD/MMM/yyyy HH:mm")
                              ),
                            ]}
                            initialValue={selectedRequirementCategory?.calculatedRDD}
                            showTime
                          />

                          <SelectInput
                            source="requirementCategory"
                            label="Requirement Category"
                            choices={selectedData?.requirementCategoryList}
                            optionText="category"
                            optionValue="id"
                            fullWidth
                            variant="outlined"
                            validate={required()}
                            onChange={requirementCategoryChangeEvent(form)}
                            onBlur={resetValidate(form)}
                            disabled={formDisabled}
                          />
                          <TextInput
                            source="customerRemark"
                            label="Remarks of Customer"
                            multiline
                            resettable
                            fullWidth
                            rows={3}
                            variant="outlined"
                            FormHelperTextProps={{
                              style: { display: "block" },
                            }}
                            disabled={formDisabled}
                            helperText="If any, remarks about the order itself should be explained such as ‘Rejection order due to corrosion’"
                            validate={remarkRequired ? required() : undefined}
                          />
                        </Grid>
                      </Grid>
                      <Separator />

                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Delivery To" />
                      </Grid>

                      <Grid {...gridContainerProps} alignItems={"flex-start"}>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="attentionName"
                            label="Attention Name"
                            initialValue={selectedAirportCode?.attentionName}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="attentionPhone"
                            label="Attention Phone"
                            initialValue={selectedAirportCode?.attentionPhone}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="shippingAddress"
                            label="Shipping Address"
                            initialValue={selectedAirportCode?.shippingAddress}
                            multiline
                            resettable
                            fullWidth
                            rows={3}
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="consigneeName"
                            label="Company/Consignee Name"
                            initialValue={selectedAirportCode?.consigneeName}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="consigneeAddress"
                            label="Company/Consignee Address"
                            initialValue={selectedAirportCode?.consigneeAddress}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="email"
                            label="E-Mail"
                            initialValue={selectedAirportCode?.email}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          {filesVisible() && (
                            <>
                              <DownloadButton
                                style={{ marginLeft: 10 }}
                                target={`download/${file?.File?.objectKey}`}
                                buttonText={file?.File?.name}
                                variant="text"
                              />
                              <FileInput
                                style={{ disabled: false }}
                                source="src"
                                label={"Defect File"}
                                multiple={false}
                                options={{ onDrop: handleFileChange }}
                                accept={FileAcceptWhiteList}
                                RaFileInput={false}
                                validate={required("You must upload defect document")}
                              >
                                <FileField source="src" title="title" label={"Defect File"} />
                              </FileInput>
                            </>
                          )}
                        </Grid>
                      </Grid>
                      <Separator />
                      <Toolbar {...props} placeholder="" classes={classes}>
                        <Button
                          label={createLoading ? "Order is creating!" : "Create Order"}
                          disabled={isSubmitButtonDisabled()}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          {createLoading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      </Toolbar>
                    </>
                  </Create>
                </Grid>
              </Grid>
              <WarningDialog />
            </>
          </form>
        );
      }}
    />
  );
};

const PbhRequestOrderCreate = props => {
  return <PostCreate resource="pbhrequestorder" basePath="pbhrequestorder" selectedData={props.selectedData} />;
};

export default PbhRequestOrderCreate;
